/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import ProductOfferDetails from './ProductOfferDetails';
import {getProductDetails, getOfferDetails} from '../../../_thunks/collection.thunk';
import {updateCopyableStatus, updateProductStage, updateOffer} from '../../../_actions/etext.publish.actions';

function mapStateToProps(state, props) {
    return {
        collectionId: state.activeCollection.collectionId,
        activeCollection: state.activeCollection,
        productDetails: state.productDetails,
        offerDetails:state.offerDetails.offerDetails,
        offerChangeDetails: state.offerDetails.offerChangeDetails,
        match: props.match,
        registrarCourseSectionDetails: state.registrarCourseSectionDetails.courseDetails
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getProductDetails : (collectionId) => {
            dispatch(getProductDetails(collectionId));
        },

        getOfferDetails : (collectionId) => {
            dispatch(getOfferDetails(collectionId));
        },
        updateCopyableStatus: (collectionId) => {
            dispatch(updateCopyableStatus(collectionId));
        },
        updateProductStage: (collectionId) => {
            dispatch(updateProductStage(collectionId));
        },
        updateOffer: (updateOfferDetails) => {
            dispatch(updateOffer(updateOfferDetails));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductOfferDetails);




// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ProductOfferDetailsLink.js